import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import DropArea from 'src/components/TranslationsContent/DropArea';
import { AllLanguages } from 'src/components/TranslationsContent/AllLanguages/AllLanguages';
import { SelectedLanguage } from 'src/components/TranslationsContent/SelectedLanguage/SelectedLanguage';
import { TranslationsContentState } from 'src/components/TranslationsContent/TranslationsContent.state';
import { MainContent } from 'src/domains/layouts/shared/layout/Layout.style';
import { ContentH3 } from 'src/domains/layouts/shared/typography/Content.style';
import { TabItem, TabsWrapper } from 'src/domains/layouts/shared/tabs/Tabs.style';

const TranslationsContentInner = observer('TranslationsContentInner', () => {
    const [state] = useState(() => new TranslationsContentState());

    const setGroupSite = (): void => state.setGroupName('site');
    const setGroupMobile = (): void => state.setGroupName('mobile');

    if (state.selectLanguageDetails !== null) {
        return <SelectedLanguage selectLanguageDetails={state.selectLanguageDetails} translationsContentState={state} />;
    }

    return (
        <>
            <ContentH3>Upload new or existing languages</ContentH3>
            <TabsWrapper>
                <TabItem isActive={state.groupName === 'site'} onClick={setGroupSite}>
                    Site
                </TabItem>
                <TabItem isActive={state.groupName === 'mobile'} onClick={setGroupMobile}>
                    Mobile
                </TabItem>
            </TabsWrapper>
            <DropArea translationsContentState={state} />
            {state.isDownloading ? <div className='spinner spinner--inline' /> : <AllLanguages state={state} />}
        </>
    );
});

export const TranslationsContent = observer('TranslationsContent', () => (
    <MainContent className='translations-content'>
        <TranslationsContentInner />
    </MainContent>
));
